import ClientTestimonials from "../../components/ClientTestimonials"
import BannerCarousel from "../../components/BannerCarousel"
import LatestPosts from "../../components/LatestPosts"
import AboutusComponent from "./AboutusComponent"
import HoroscopeList from "./HoroscopeList"
import TopServicesSection from "../../components/TopServicesSection"
import ServicesCarousel from "../../components/ServicesCarousel"
import PopularProducts from "../../components/PopularProducts"

const DashboardComponent = () => (
  <>
    <BannerCarousel />
    <TopServicesSection />
    <ServicesCarousel />

    <div className="container">
      <HoroscopeList />
    </div>

    <ClientTestimonials />

    <PopularProducts />

    <LatestPosts />
    <AboutusComponent />
  </>
)

export default DashboardComponent
